import { render, staticRenderFns } from "./QuestionBankTopic.vue?vue&type=template&id=b51f0b68&scoped=true&"
import script from "./QuestionBankTopic.vue?vue&type=script&lang=js&"
export * from "./QuestionBankTopic.vue?vue&type=script&lang=js&"
import style0 from "./QuestionBankTopic.vue?vue&type=style&index=0&id=b51f0b68&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b51f0b68",
  null
  
)

export default component.exports